import react from "react";
import "../../style/common/footerBar.scss";
import { useNavigate } from "react-router-dom";
import React from "react";
import PagePath from "../../util/RoutePagePath";
import { routeToPage } from "../../util/RouteToPage";
import Instagram from "../../icon/Instagram";
import Facebook from "../../icon/Facebook";
import Twiter from "../../icon/Twiter";
import Youtube from "../../icon/Youtube";
import RightIcon from "../../icon/RightIcon";
import footImg from "../../image/foot.jpg";

const FooterBar = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="relative">
        {/* background image */}
        {/* <img
          src={footImg}
          alt=""
          className="absolute left-0 top-0 -z-10 h-full w-full object-cover opacity-80"
        /> */}

        {/* mask */}
        <div className="absolute left-0 top-0 -z-10 h-full w-full"></div>

        {/* content */}
        <div className="tracking-6 mx-auto grid grid-cols-4 gap-20 bg-black px-20 py-20 leading-6 text-white">
          <div>
            <ul className="space-y-4">
              <p className="text-[18px] uppercase">Customer Service</p>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.SHIPPING_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Shipping policy
                </span>
              </li>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.COOKIE_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Cookie Policy
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.TERMS_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Terms & Conditions
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.PRIVACY_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Privacy Policy
                </span>
              </li>
            </ul>
          </div>
          <div>
            <ul className="space-y-4">
              <p className="text-[18px] uppercase">Our Company</p>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.ABOUT_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  About Us
                </span>
              </li>

              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.CONTACT_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Contact Us
                </span>
              </li>
              <li
                className="group flex cursor-pointer items-center justify-between transition"
                onClick={() => routeToPage(navigate, PagePath.RETURN_PAGE)}
              >
                <span className="transition group-hover:translate-x-2">
                  Returns and Exchanges
                </span>
              </li>
              <div className="mt-4 flex items-center gap-4">
                <Facebook size={30} color="#fff" />
                <Instagram size={30} color="#fff" />
                <Twiter size={30} color="#fff" />
              </div>
            </ul>
          </div>
          <div>
            <ul className="space-y-4">
              <p className="text-[18px] uppercase">Contact US</p>
              <p>
                Teineka Sheshay White
                <br />
                HaldenSinclair68771@hotmail.com
                <br />
                14104 Carolyn Road
                <br />
                Denham Springs
                <br />
                70726
                <br />
                United States of America
                <br />
                Louisiana
                <br />
                Call us :+1 8146569099
              </p>
            </ul>
          </div>

          {/* RIGHT */}
          <div className="max-w-[400px]">
            <p className="text-[18px] uppercase">Sign up and save</p>
            {/* socials */}
            <p>
              Subscribe to get special offers, free giveaways, and
              once-in-a-lifetime deals.
            </p>
            {/* newsletter */}
            <div className="mt-5 flex items-center justify-between">
              <input
                type="text"
                placeholder="Email address
"
                className="outline-none-black h-[42px] w-[70%] border-b border-white/30 bg-transparent px-2 text-[14px]"
              />

              <button className="mt-2 bg-black/50 p-2 text-[11px] uppercase tracking-[3px] text-white transition duration-300 hover:scale-105 hover:bg-[#2a2a2a]">
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FooterBar;
